// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__1B1_q","summary":"CartItem_summary__3FMDj","price":"CartItem_price__2Nl0j","amount":"CartItem_amount__jUKEC","actions":"CartItem_actions__UwVPJ"};